EMMY.prevetting = {
  savePrevetValue: function() {
    $('#prevet-save-button').text('Saving...');

    $.ajax({
      url: $('#pre-vet-response-form').attr('action'),
      type: 'post',
      data: $('#pre-vet-response-form').serialize(),
      success: function (data) {
        // need some way to show success
        if (data != 1) {
          alert('something went wrong, please try again or contact awards.');
        } else {
          $('#prevet-save-button').text('Saved!');
          setTimeout(function(){
            $('#prevet-save-button').text('Save');
          }, 1000);
        }
      }
    })
  },
  init: function () {
    // console.log('loaded prevetting');


    $('#categories').on('change', function(e) {
      $('#searchForm').submit();
    });

    $('.prevet-save-button').on('click', function(e){
      e.stopPropagation();
      e.preventDefault();
      //EMMY.prevetting.savePrevetValue();
    });

    $(document).on('change', 'input[name=response_field]', function(e) {
      EMMY.prevetting.savePrevetValue()
    });
  },
};
